
import { computed, defineComponent, onMounted, ref, Ref } from "vue";
import Room from "../interfaces/Room/Room.interface";
import RoomStats from "../interfaces/Room/RoomStats.interface";
import { useStore } from "../store";

export default defineComponent({
  name: "RoomCard",
  props: {
    room: {
      required: true,
      type: Object as () => Room,
    },
    isAdmin: {
      required: true,
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const stats: Ref<RoomStats> = ref({
      totalHoursOfReservations: 0,
    });

    onMounted(async () => {
      const response = await store.dispatch("getRoomStatistics", props.room.roomCode);
      if (response === null) return;
      stats.value = response;
    });

    const deleteRoom = async () => {
      if (window.confirm("Are you sure you want do delete the room?")) {
        if (await store.dispatch("deleteRoom", props.room.roomCode)) {
          emit("reload");
        }
      }
    };

    

    const chatLink = computed(() => {
      return "/chat/" + props.room.roomCode;
      
      })

    return {
      deleteRoom,
      stats,
      chatLink,
    };
  },
});
